export default __webpack_public_path__ + "static/media/pavillion.bf555352.svg";